import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";


@Injectable()
export class MandantenData {
  public data: any;
  constructor(public http: Http, public userData: UserData, public common: CommonData) {
    
  }

  mandateby(id){
    for(let i=0; i<this.data.length; i++){
      if(this.data[i].mandid == id){
        return this.data[i];                
      }
    }
    return null;
  }

  public getMandateName(mandid){
    let mandat =  this.mandateby(mandid);
    if(mandat){
      return mandat.mandat;
    }
    else{
      return mandid;
    }

  }

  load(){
    return new Promise(resolve => {
      let params = JSON.stringify({ token: this.userData.jwt});    
    
      this.http.post(this.common.baseurl+'mandanten/index',params)
        .subscribe(data => {          
          let response = data.json();
          
          if(response.success === true){
              this.data = response.data;
              //console.log(this.data);
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.data = [];
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }

}



// WEBPACK FOOTER //
// ./src/providers/mandanten-data.ts